import * as React from "react";
import { formatPhone } from "shared/plugins/string-helper";
import { ICustomerAddressModel } from "states/customer-address/customer-address.models";
interface IAddressViewItem {
  model: ICustomerAddressModel;
  isView?: boolean;
}
export function AddressViewItem  ({ model,isView }: IAddressViewItem){
  return (
    <div className="text-left space-y-2">
      <div className="name font-semibold">{model.addressInfo?.firstName.toUpperCase()} {model.addressInfo?.lastName.toUpperCase()} {isView ? <span className="text--primary">(Change Address)</span>:``}</div>
      <div className="phone">Phone: {model.addressInfo?.phoneNumber && formatPhone(model.addressInfo?.phoneNumber)}</div>
      <div className="address">Address: {model.addressInfo?.street}, <br /> {model.addressInfo?.provinceName}, {model.addressInfo?.stateCode} {model.addressInfo?.postalCode}, {model.addressInfo?.countryName}</div>
    </div>
  );
};
